<div class="page-tabs-widget" [style.column-gap.px]='gap' [style.grid-template-columns]='gridTemplateColumns()'>

	<div [style.height.px]='contentHeight'>

		@if(tab1ShouldExpand()) {
		<div class="tab-expander-button">
			<button (click)='toggleForce()'><i class='toggle-not-hovered fa-regular fa-left-right'></i><i
					class='toggle-hovered fa-solid fa-left-right'></i></button>
		</div>
		}

		<kendo-tabstrip [keepTabContent]='true' class='page-tabs-tabstrip' [style.height.px]='contentHeight'
			(tabSelect)="onTabSelect('left', $event)">

			<kendo-tabstrip-tab [title]='tabNames()[0] || "1"' [selected]="leftTabIndex() === 0">
				<ng-template kendoTabContent>
					<ng-container *ngTemplateOutlet="pageTab1()?.tpl || defaultTemplate"></ng-container>
				</ng-template>
			</kendo-tabstrip-tab>


			@if(!tab1Expanded()){

			@for (tab of extraTabs; track $index; let i=$index) {
			<kendo-tabstrip-tab [title]='tab.name' [selected]="leftTabIndex() === i + 1">
				<ng-template kendoTabContent>
					<ng-container *ngTemplateOutlet="tab.template || defaultTemplate"></ng-container>
				</ng-template>
			</kendo-tabstrip-tab>
			}

			}

		</kendo-tabstrip>
	</div>

	@if(tab1Expanded()){
	<kendo-tabstrip [keepTabContent]='true' class='page-tabs-tabstrip' [style.height.px]='contentHeight'
		(tabSelect)="onTabSelect('right', $event)">

		@for (tab of extraTabs; track $index; let i=$index) {
		<kendo-tabstrip-tab [title]='tab.name' [selected]="rightTabIndex() === i + 1">
			<ng-template kendoTabContent>
				<ng-container *ngTemplateOutlet="tab.template || defaultTemplate"></ng-container>
			</ng-template>

		</kendo-tabstrip-tab>
		}
	</kendo-tabstrip>
	}

	<ng-template #defaultTemplate>
		<i style='display:block; margin-top:2em; color: crimson;'>Template not provided</i>
		<pre>{{tabNames() | json}}</pre>
		<br>
		left: {{ leftTabIndex() }}
		<br>
		right: {{ rightTabIndex() }}
	</ng-template>

</div>